import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { getExercises } from '../api';

const ExercisePage = () => {
  const { bodyPart } = useParams();
  const [exercises, setExercises] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const navigate = useNavigate();

  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);
    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);
    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  useEffect(() => {
    getExercises()
      .then((res) => {
        const filtered = res.data.filter((e) => e.parentName === bodyPart);
        setExercises(filtered);
      })
      .catch((err) => console.error(err))
      .finally(() => setLoading(false));
  }, [bodyPart]);

  if (loading) return <div className="loading">読み込み中...</div>;

  return (
    <div className="page">
      <h1>{bodyPart}の種目を選択</h1>
      {!isOnline && (
        <div className="offline-banner">
          📵 オフラインモード｜キャッシュから表示しています
        </div>
      )}
      <button className="back-button" onClick={() => navigate('/')}>
        ← 部位選択に戻る
      </button>
      {exercises.length === 0 ? (
        <p className="empty-message">種目データを読み込めませんでした。一度オンラインで起動してください。</p>
      ) : (
        <div className="card-list">
          {exercises
            .sort((a, b) => a.displayOrder - b.displayOrder)
            .map((exercise) => (
              <button
                key={exercise.name}
                className="card"
                onClick={() => navigate(`/record/${bodyPart}/${exercise.name}`)}
              >
                {exercise.name}
              </button>
            ))}
        </div>
      )}
    </div>
  );
};

export default ExercisePage;